module.exports = __webpack_public_path__ + "static/media/icn-challenges-warn-white.adb6404a.svg";